import './shared'
import './init'
import Form from './form'
import Router from 'live/services/router'
import ExtensionService from 'live/services/extension'

const googlePlugin = {
    name: 'Google Maps',
    type: 'googlemaps',
    origin: 'Plugin Google Maps',
    icon: '/content/plugin-extension-google/google-maps.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(googlePlugin)


